import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-589685ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "binding" }
const _hoisted_2 = {
  key: 0,
  class: "binding-latest"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上次登录时间：2021-01-08 14:42:19", -1))
const _hoisted_4 = { class: "binding-list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "binding-list-title" }, "账号安全", -1))
const _hoisted_6 = { class: "binding-list-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-email" }, null, -1))
const _hoisted_8 = { class: "binding-list-item-content" }
const _hoisted_9 = { class: "binding-list-item-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "binding-list-item-desc" }, "绑定邮箱后，邮箱可以用于接收资料，可用于找回密码", -1))
const _hoisted_11 = { class: "binding-list-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-app" }, null, -1))
const _hoisted_13 = { class: "binding-list-item-content" }
const _hoisted_14 = { class: "binding-list-item-title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "binding-list-item-desc" }, "绑定手机号可以获得更加优质的服务，可用于找回密码", -1))
const _hoisted_16 = { class: "binding-list-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-password" }, null, -1))
const _hoisted_18 = { class: "binding-list-item-content" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "binding-list-item-title" }, "密码", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "binding-list-item-desc" }, "用于保护账号信息和登录安全", -1))

import { defineComponent, onBeforeMount, reactive, ref } from 'vue'
import { getUserBinding } from '@/api/user'
import { BindingConfig } from '@/types'
import { ERR_SUCCESS } from '@/api/config'
import UserBindingEmail from '@/components/user/binding/email.vue'
import UserBindingMobile from '@/components/user/binding/mobile.vue'
import UserModifyPassword from '@/components/user/binding/password.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const dialogVisible = ref(false)
const showLatest = ref(false)
const bindingInfo = reactive<BindingConfig>({
  email: '',
  // eslint-disable-next-line @typescript-eslint/camelcase
  email_verify_status: false,
  mobile: '',
  // eslint-disable-next-line @typescript-eslint/camelcase
  mobile_verify_status: false
})
const formTypes = reactive({
  email: false,
  mobile: false,
  password: false
})

defineComponent([
  'UserBindingEmail', 'UserBindingMobile'
])

const getBindInfo = async () => {
  const { code, result } = await getUserBinding()
  if (code === ERR_SUCCESS) {
    Object.assign(bindingInfo, result)
  }
}

onBeforeMount(getBindInfo)

const showDialog = (formType: keyof typeof formTypes) => {
  dialogVisible.value = true
  for (const key in formTypes) {
    if (Object.prototype.hasOwnProperty.call(formTypes, key)) {
      (formTypes as Record<string, boolean>)[key] = key === formType
    }
  }
}

const hideDialog = () => {
  dialogVisible.value = false
  getBindInfo()
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "slide-up" }, {
      default: _withCtx(() => [
        (showLatest.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", null, [
                _createTextVNode("地点："),
                _createVNode(_component_router_link, { to: "/user/log" }, {
                  default: _withCtx(() => [
                    _createTextVNode("查看最近操作记录")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("i", {
                class: "iconfont icon-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showLatest.value=false))
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(UserBindingEmail, {
          email: bindingInfo.email,
          hideDialog: hideDialog
        }, null, 8, ["email"]), [
          [_vShow, formTypes.email]
        ]),
        _withDirectives(_createVNode(UserBindingMobile, {
          mobile: bindingInfo.mobile,
          hideDialog: hideDialog
        }, null, 8, ["mobile"]), [
          [_vShow, formTypes.mobile]
        ]),
        _withDirectives(_createVNode(UserModifyPassword, { hideDialog: hideDialog }, null, 512), [
          [_vShow, formTypes.password]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("dl", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("dd", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, "邮箱 " + _toDisplayString(bindingInfo.email_verify_status ? bindingInfo.email + ' 已绑定' : '未绑定'), 1),
          _hoisted_10,
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showDialog('email'))),
            disabled: bindingInfo.email_verify_status
          }, {
            default: _withCtx(() => [
              _createTextVNode("绑定邮箱")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("dd", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, "手机 " + _toDisplayString(bindingInfo.mobile_verify_status ? bindingInfo.mobile + ' 已绑定' : '未绑定'), 1),
          _hoisted_15,
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialog('mobile'))),
            disabled: bindingInfo.mobile_verify_status
          }, {
            default: _withCtx(() => [
              _createTextVNode("绑定手机")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("dd", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _hoisted_20,
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showDialog('password')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("修改密码")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})